import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/Button';
import { CloseIcon } from '../../../../icons';
import { palette } from '../../../../styles/_palette';
import { ButtonType } from '../../../../styled/theme/types';

const FiltersHeader = ({
  title,
  close,
  handleReset,
  isDisabled,
  cypress,
  isCloseIcon
}) => {
  const { t } = useTranslation();

  return (
    <div className="new-search-popup__header">
      <div className="new-search-popup__header-action">
        {isCloseIcon ? (
          <Button
            state="link"
            onClick={close}
            styles="height: 60px"
            cypress="new-search-popup-header-btn-close"
          >
            <CloseIcon fill={palette.heatheredGrey} width={15} height={15} />
          </Button>
        ) : (
          <button
            type="button"
            className="new-search-popup__header-btn new-search-popup__header-btn--close"
            data-cy="new-search-popup-header-btn-close"
            onClick={close}
          />
        )}
      </div>
      <h2 className="new-search-popup__header-title" data-cy={cypress}>
        {title}
      </h2>
      {handleReset && (
        <div className="new-search-popup__header-action__right">
          <Button
            text={t('common.reset')}
            onClick={handleReset}
            state={ButtonType.link}
            disabled={isDisabled}
            cypress="new-search-popup-reset-btn"
            stat="new-search-popup-reset-btn"
            styles="height: 60px"
          />
        </div>
      )}
    </div>
  );
};

FiltersHeader.propTypes = {
  close: PropTypes.func,
  title: PropTypes.string,
  cypress: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleReset: PropTypes.func,
  isCloseIcon: PropTypes.bool
};

export default FiltersHeader;
